import { createSlice } from "@reduxjs/toolkit";
import {
  fetchCategoryFormSettings,
  updateCategoryFormSettings,
  createCategoryFormSettings,
  fetchLatestCategoryFormSettings,
} from "../Actions/CategoryFormSettingsAction";
import { CategoryFormSettingsState } from "../../modules/shared/model";

const initialState: CategoryFormSettingsState = {
  settings: null,
  setting: null,
  loading: false,
  error: null,
};

const categoryFormSettingsSlice = createSlice({
  name: "categoryFormSettings",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSettings: (state) => {
      state.settings = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // Fetch settings
    builder
      .addCase(fetchCategoryFormSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategoryFormSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.settings = action.payload;
        state.error = null;
      })
      .addCase(fetchCategoryFormSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // Update settings
    builder
      .addCase(updateCategoryFormSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCategoryFormSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.settings = action.payload;
        state.error = null;
      })
      .addCase(updateCategoryFormSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // Create settings
    builder
      .addCase(createCategoryFormSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createCategoryFormSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.settings = action.payload;
        state.error = null;
      })
      .addCase(createCategoryFormSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // Fetch latest settings
    builder
      .addCase(fetchLatestCategoryFormSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLatestCategoryFormSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.setting = action.payload;
        state.error = null;
      })
      .addCase(fetchLatestCategoryFormSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearError, clearSettings } = categoryFormSettingsSlice.actions;
export default categoryFormSettingsSlice.reducer;
